import {CountUp} from "countup.js";

export default function handleCountUpElements() {
    $('.js-count-up').each(function () {
        handleCountUpElement($(this));
    });
}

function handleCountUpElement($element) {
    let options = {};
    let maxVal = 'undefined' === typeof $element.data('max-value') ? 0 : $element.data('max-value');
    options.suffix = 'undefined' === typeof $element.data('suffix') ? '' : $element.data('suffix');
    options.prefix = 'undefined' === typeof $element.data('prefix') ? '' : $element.data('prefix');

    let countUp = new CountUp($element[0], maxVal, options);
    $element.data('countUp', countUp);

    if (countUp.error) {
        console.error(countUp.error);
        return;
    }

    if ($element.is('.a__i')) {
        $element.on('animationItemDone', () => {
            countUp.start();
        });
    } else {
        countUp.start();
    }
}